<script>
import { mapState, mapWritableState, mapActions } from "pinia";
import { useAppStore } from "@/store/modules/app";
import { useTasksStore } from "@/store/modules/tasks";
import { useProjectsStore } from "@/store/modules/projects";
import Button from "primevue/button";
import Drawer from 'primevue/drawer';
import Menu from 'primevue/menu';

  export default {
    name: "HeaderMain",
    components: { Button, Drawer, Menu },
    data() {
      return {
        switches: {
          headMenuOpened: false,
          leftMenuOpened: false,
          searchOpened: false
        },
        searchTimeout: null, // Таймер для дебаунсинга
        leftMenu: [
          {
            label: 'НАСТРОЙКИ',
            items: [
              {
                label: 'Профиль',
                icon: 'pi pi-user',
                //style: { opacity: 0.6 }, // Делаем текст более светлым
                command: () => {
                  /*this.$root.$toast.add({
                    severity: 'info',
                    summary: 'Информация',
                    detail: 'Раздел находится в разработке',
                    life: 4000
                  });*/
                  this.toggleLeftMenu()
                  this.$router.push('/settings/profile')
                }
              },
              {
                label: 'Уведомления',
                icon: 'pi pi-bell',
                command: () => {
                  this.toggleLeftMenu()
                  this.$router.push('/settings/notifications');
                }
              }
            ]
          }
        ]
      };
    },
    methods: {
      ...mapActions(useTasksStore, ['resetTasks', 'loadTasks']),
      ...mapActions(useAppStore, ['setSort', 'setFilter', 'getBackRoute']),
      toggleHeadMenu() {
        this.switches.headMenuOpened = !this.switches.headMenuOpened;
      },
      toggleLeftMenu() {
        this.switches.leftMenuOpened = !this.switches.leftMenuOpened;
      },
      handleClickOutside(event) {
        const menu = this.$el.querySelector('.header__menu');
        const menuButton = this.$el.querySelector('[aria-label="toggle-menu"]');
        const menuOverlay = this.$el.querySelector('.header__menu-overlay');

        if (
            this.switches.headMenuOpened &&
            !menu.contains(event.target) &&
            (!menuButton || !menuButton.contains(event.target)) &&
            (!menuOverlay || !menuOverlay.contains(event.target))
        ) {
          this.switches.headMenuOpened = false
        }
      },
      goBack() {
        const backRoute = this.getBackRoute(this.$route)

        if (backRoute.includes(':id')) {
          const id = this.$route.params.id;
          this.$router.push(backRoute.replace(':id', id));
        } else {
          this.$router.push(backRoute);
        }
      },
      toggleSearch() {
        if (this.switches.searchOpened) {
          this.clearSearch()
        }

        this.switches.searchOpened = !this.switches.searchOpened

        // фокусируемся на инпуте
        if (this.switches.searchOpened) {
          this.$nextTick(() => {
            const searchInput = this.$el.querySelector('.header__search-input input')

            if (searchInput) {
              searchInput.focus()
            }
          })
        }
      },
      hasAction(action) {
        return this.$route.meta[action + 'Action'] || false;
      },
      cancelProjectFilter() {
        this.selectedProject = { ID: null, TITLE: null }
        this.resetTasks()
        this.loadTasks(this.$root)
      },
      clearSearch() {
        this.q = ''
        this.searchTasks()
      },
      handleSearchInput() {
        const $this = this

        // Очищаем предыдущий таймер
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout)
        }

        // Если введено меньше 3 символов, сбрасываем поиск
        if (this.q.length < 4) {
          if (this.q.length === 0) {
            // Если строка пустая, сбрасываем поиск
            this.searchTimeout = setTimeout(() => {
              $this.searchTasks()
            }, 300) // небольшая задержка для плавности
          } else {
            // Не выполняем поиск для 1-2 символов
            return
          }
        } else {
          // Устанавливаем новый таймер для поиска (более 3 символов)
          this.searchTimeout = setTimeout(() => {
            $this.searchTasks()
          }, 1000)
        }
      },
      searchTasks() {
        this.resetTasks()
        this.loadTasks(this.$root)
      }
    },
    computed: {
      ...mapWritableState(useProjectsStore, ['selectedProject']),
      ...mapWritableState(useTasksStore, ['q']),
      ...mapState(useAppStore, ['lastPath', 'headMenu', 'currentTaskTitle']),
      headerType() {
        return this.$route.meta.headerType || 'default'
      }
    },
    watch: {
      '$route'(to, from) {
        console.log('Переход с', from.path, 'на', to.path)
        this.switches.headMenuOpened = false
      }
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside)
    },
    beforeUnmount() {
      document.removeEventListener('click', this.handleClickOutside)

      // Очищаем таймер при размонтировании компонента
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
    }
  };
</script>

<template>
  <header class="header">
    <div class="header__inner" v-if="headerType === 'default'">
      <div class="header__main" v-show="!switches.searchOpened">
        <div class="header__logo">
          <button @click="toggleLeftMenu" class="pi pi-bars" style="font-size: 1.43rem"></button>
          <!--<img src="img/logo.svg" alt="logo">-->
          <h6 class="h6">{{ $route.meta.title }}</h6>
        </div>
        <Button
            @click="cancelProjectFilter"
            v-if="hasAction('headerProject') && selectedProject.ID"
            :label="selectedProject.TITLE"
            icon="pi pi-times"
            size="small"
            variant="outlined"
            severity="secondary"
        />
        <div class="header__actions">
          <button v-if="hasAction('headerMenu')" @click="toggleSearch" aria-label="toggle-search">
            <i class="pi pi-search" style="font-size: 1.43rem"></i>
          </button>
          <button v-if="hasAction('headerMenu')" @click="toggleHeadMenu" aria-label="toggle-menu">
            <i class="pi pi-sliders-h" style="font-size: 1.43rem"></i>
          </button>
          <div class="header__menu-wrap">
            <div
                class="header__menu-overlay"
                v-if="switches.headMenuOpened"
                @click="switches.headMenuOpened = false"
            ></div>
            <div class="header__menu" :class="{'header__menu--opened': switches.headMenuOpened}">
              <div class="header__menu-category" v-if="headMenu.tasks.sort.length > 0">
                <span class="header__menu-title">Сортировка</span>
                <ul class="header__menu-items">
                  <li
                      v-for="(item, i) in headMenu.tasks.sort"
                      :key="i"
                      class="header__menu-item text-subhead--light"
                      :class="{'header__menu-item--selected': item.selected}"
                  >
                    <a href="#" @click.prevent="setSort(i, 'tasks')">{{ item.name }}</a>
                  </li>
                </ul>
              </div>
              <div class="header__menu-category" v-if="headMenu.tasks.filter.length > 0">
                <span class="header__menu-title">Быстрый фильтр</span>
                <ul class="header__menu-items">
                  <li
                      v-for="(item, i) in headMenu.tasks.filter"
                      :key="i"
                      class="header__menu-item text-subhead--light"
                      :class="{'header__menu-item--selected': item.selected}"
                  >
                    <a href="#" @click.prevent="setFilter(i, 'tasks')">{{ item.name }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header__action" :class="{'header__action--active': switches.searchOpened}">
        <form action="" class="header__search">
          <div class="header__search-input">
            <button class="header__search-cancel" @click.prevent="toggleSearch">
              <i class="pi pi-arrow-left" style="font-size: 1.43rem"></i>
            </button>
            <input
                type="text"
                placeholder="Поиск..."
                v-model="q"
                @input="handleSearchInput"
            >
            <button
                v-if="q"
                class="header__search-clear"
                @click.prevent="clearSearch"
            >
              <i class="pi pi-times" style="font-size: 1.43rem"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="header__inner" v-if="headerType === 'back'">
      <div class="header__action header__action--active">
        <div class="header__action-inner">
          <a href="#" @click.prevent="goBack" class="header__action-btn">
            <svg class="icon">
              <use href="img/svgsprite/sprite.symbol.svg#icon-arrow-left" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
            </svg>
          </a>
          <div class="header__action-head">
            <span class="header__action-title">{{ $route.meta.title }}</span>
            <span>{{ currentTaskTitle }}</span>
          </div>
        </div>
      </div>
    </div>
    <Drawer v-model:visible="switches.leftMenuOpened">
      <template #container="{ closeCallback }">
        <div class="lmenu__header">
          <div class="lmenu__logo">
            <img src="img/logo.svg" alt="logo">
            <span class="h6">Главное меню</span>
          </div>
          <Button type="button" @click="closeCallback" icon="pi pi-times" severity="secondary" variant="text" rounded size="large"></Button>
        </div>
        <Menu :model="leftMenu" />
        <div class="lmenu__footer">
          <span class="sheet__loading-text">Версия {{ $root.version }}</span>
        </div>
      </template>
    </Drawer>
  </header>
</template>

<style scoped>
.header__action-head {
  display: flex;
  flex-direction: column;
}

.header__action {
  width: 100%;
  padding-top: 0;
}

.header__action-title {
  display: block;
  font-size: 1.2rem;
}

.lmenu__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: var(--p-menu-item-padding);
  border-bottom: 1px solid var(--p-menu-border-color);
}

.lmenu__logo {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.lmenu__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  flex-shrink: 0;
  padding: var(--p-menu-item-padding);
  border-top: 1px solid var(--p-menu-border-color);
}

.header__actions {
  color: #000;
}

.header__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header__main {
  width: 100%;
}

.header__menu-overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.header__menu {
  position: relative;
  z-index: 20;
}

.header__menu-category {
  position: relative;
}

.header__search-input {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1.43rem;
}

.header__search-clear {
  height: 1.43rem;
  width: 1.43rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  margin-left: 0.5rem;
}

button, input[type=submit] {
  display: inline-block;
  box-shadow: none;
  background-color: transparent;
  background: 0 0;
  cursor: pointer;
  border: none;
  padding: 0;
}

.header__search-input input {
  flex-grow: 1;
  font-size: 1.14rem;
  height: 100%;
  padding-right: 2rem; /* Добавляем отступ для крестика */
}
</style>